import React, { FC, ReactNode } from 'react';
import { Notification } from 'snacks-design-system';

/* https://snacks.takeaway.com/portal/components/notification/usage/ */

export enum IPieNotificationMode {
  Neutral = 'neutral',
  NeutralAlt = 'neutral-alt',
  Info = 'info',
  Positive = 'positive',
  Warning = 'warning',
  Error = 'error',
}

interface IPieNotificationProps {
  children?: React.ReactNode;
  mode: IPieNotificationMode;
  isOpen?: boolean;
  showClose?: boolean;
  icon?: ReactNode;
  showIcon?: boolean;
  autoCloseTimeout?: number;
  backgroundImgSrc?: string;
  secondaryActionButtonProps?: object;
  primaryActionButtonProps?: object;
  borderRadius?: 'auto' | 'none' | 'large';
  modActionCompact?: boolean;
  modInline?: boolean;
  modColorInverse?: boolean;
  onClose?: (options?: any) => void;
}

export const PIENotification: FC<IPieNotificationProps> = ({
  children,
  mode,
  isOpen,
  icon,
  showIcon,
  showClose,
  autoCloseTimeout,
  backgroundImgSrc,
  secondaryActionButtonProps,
  primaryActionButtonProps,
  borderRadius,
  modActionCompact,
  modColorInverse,
  modInline,
  onClose,
}) => {
  const handleOnClose = () => {
    onClose && onClose();
  };
  return (
    <Notification
      isOpen={isOpen}
      showClose={showClose}
      showIcon={showIcon}
      mode={mode}
      icon={icon}
      autoCloseTimeout={autoCloseTimeout}
      backgroundImgSrc={backgroundImgSrc}
      secondaryActionButtonProps={secondaryActionButtonProps}
      primaryActionButtonProps={primaryActionButtonProps}
      borderRadius={borderRadius}
      modActionCompact={modActionCompact}
      modColorInverse={modColorInverse}
      modInline={modInline}
      onClose={handleOnClose}
    >
      {children}
    </Notification>
  );
};

export default PIENotification;
